import React from 'react'
import { Remove, Add } from '@mui/icons-material'
import { Grid, IconButton, useTheme } from '@mui/material'
import { useControls } from 'react-zoom-pan-pinch'

export const ZoomControls = () => {
  const { zoomIn, zoomOut, instance } = useControls()
  const theme = useTheme()

  return (
    <Grid container spacing={0} width="min-content" item justifyContent="space-between" flexDirection="column">
      <Grid item>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            zoomIn()
            e.currentTarget.blur()
          }}>
          <Add htmlColor={`${theme.palette.secondary.main}`} />
        </IconButton>
      </Grid>

      <Grid item>
        <IconButton
          size="small"
          disabled={instance.transformState.scale < 1}
          sx={{
            '& *': {
              opacity: instance.transformState.scale < 1 ? '50%' : '100%'
            }
          }}
          onClick={(e) => {
            e.stopPropagation()
            zoomOut()
            e.currentTarget.blur()
          }}>
          <Remove htmlColor={`${theme.palette.secondary.main}`} />
        </IconButton>
      </Grid>
    </Grid>
  )
}
